import { render, staticRenderFns } from "./UserRoleChange.vue?vue&type=template&id=424397e4"
import script from "./UserRoleChange.js?vue&type=script&lang=js&external"
export * from "./UserRoleChange.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports